import { AttrField, OrmModel } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import FormDetails from '@/data/models/domain/services/forms/FormDetails'
import type {
  SubscribeCustomFieldComposed,
  SubscribeFormComposed,
} from '@/services/domain/services/forms/subscribe/types'

@OrmModel(modelNames.FORM_SUBSCRIBE_DETAILS)
export default class FormSubscribeDetails extends FormDetails<SubscribeFormComposed> {
  @AttrField([])
  public customFields: SubscribeCustomFieldComposed[]
}
